import { Component } from '@angular/core';
import { ActionSheetController, ModalController } from '@ionic/angular';
import {
  fadeInOutTransition,
  slideInOutTransition,
} from '@order/pages/order-exceptions/animations/order-exception.animation';
import { ExceptionProductBaseComponent } from '../../exception-product-base.component';
import { PanAppState } from '@panamax/app-state';

@Component({
  selector: 'app-exception-product-desktop',
  templateUrl: './exception-product-desktop.component.html',
  styleUrls: ['./exception-product-desktop.component.scss'],
  animations: [fadeInOutTransition, slideInOutTransition],
})
export class ExceptionProductDesktopComponent extends ExceptionProductBaseComponent {
  constructor(
    protected modalController: ModalController,
    protected actionSheetController: ActionSheetController,
    readonly panAppState: PanAppState,
  ) {
    super(modalController, actionSheetController, panAppState);
  }
}
